import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { relationshipScoreQuerySchema } from './relationship-score-query-schema';

export const relationshipScoreFormSchema = relationshipScoreQuerySchema
  .omit({ label: true, status: true, number: true, clients_count: true })
  .extend({
    label: z.string().min(3),
    number: z.string(),
    status: statusFormSchema,
  });

export type RelationshipScoreFormSchema = z.infer<typeof relationshipScoreFormSchema>;
